import { useEffect } from "react"

export function useElementEvent<K extends keyof HTMLElementEventMap, T extends HTMLElement>(
  target: T | null,
  type: K,
  handler: (ev: HTMLElementEventMap[K]) => void,
  deps: Array<unknown>,
  options?: boolean | AddEventListenerOptions
) {
  useEffect(() => {
    if (!(target && target.addEventListener)) {
      return
    }

    target.addEventListener(type, handler, options)

    return () => {
      target.removeEventListener(type, handler)
    }
  }, [target, type, handler, JSON.stringify(options), ...deps])
}
